import OfferPageStateContext from 'contexts/OfferPage/offerPageStateContext'
import { OfferPageState, coverByOffersStates } from 'contexts/OfferPage/offerPageStateReducer'
import { useAppSelector } from 'hooks/reduxHooks'
import { useContext } from 'react'

import { isAvailableForPurchase } from 'selectors/offerPage/offerPageSelectors'

function useIsAvailableForPurchase(offerState?: OfferPageState) {
  const offerPageState = useContext(OfferPageStateContext) ?? offerState
  const availables = useAppSelector((state) => coverByOffersStates(isAvailableForPurchase, offerPageState, state))

  return availables.every((available) => available)
}

export default useIsAvailableForPurchase
